import Header from './components/Header';
import HeroSection from './components/HeroSection';
import DropdownSection from './components/DropdownSection';
import WhatIsSection from './components/WhatIsSection';
import ComparisonSection from './components/ComparisonSection';
import CategoryGrid from './components/CategoryGrid';
import ReviewSection from './components/ReviewSection';
import FAQSection from './components/FAQSection';
import ArticleLinkSection from './components/ArticleLinkSection';
import ArticleCardsSection from './components/ArticleCardsSection';
import Footer from './components/Footer';
import { siteUrl } from '@/mocks/categories';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <DropdownSection />
        <article>
          <WhatIsSection />
        </article>
        <ComparisonSection />
        <CategoryGrid />
        <ArticleCardsSection />
        <ReviewSection />
        <FAQSection />
        <ArticleLinkSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Sugargoo Spreadsheet',
            url: siteUrl + '/',
            logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
            description:
              'The ultimate Sugargoo Spreadsheet database for 2026. Discover updated product finds, shopping guides, price comparisons, and expert resources.',
            sameAs: [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Sugargoo Spreadsheet',
            url: siteUrl + '/',
            description:
              'The ultimate Sugargoo Spreadsheet database for 2026. Discover updated product finds, shopping guides, price comparisons, and expert resources.',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </>
  );
}